<template>
  <div class="template-container">
      <div class="card-black">
        <div class="card-header">
        <!-- Per tornare indietro -->
        <a href="#/user" class="icon-link">
          <span class="material-icons">chevron_left</span>
        </a>
        <span class="white-text">Fusco Fit</span>
        <!-- Per andare alla home -->
        <a href="#/user" class="icon-link">
          <span class="material-icons">home</span>
        </a>
      </div>
          <div class="prenotazioni-riepilogo">
  <h2>Le tue prenotazioni</h2>
  <p>PUOI PRENOTARE UN SOLO SLOT PER LA TUA VIDEO CALL</p>

  <div v-if="prenotazioniUtente && prenotazioniUtente.length > 0">
    <div v-for="prenotazione in prenotazioniUtente" :key="prenotazione.id" class="prenotazione">
  <p>{{ formattaData(prenotazione.data) }} - Orario: {{ prenotazione.orario }}</p>
</div>

  </div>
  <div v-else>
    <p>Nessuna prenotazione trovata.</p>
  </div>
  </div>
<!-- Cicla sui giorni -->
<div v-for="(slots, date) in slotsByDate" :key="date" class="card-black-orders">
  <div class="card-header2" @click="toggleAccordion(date)">
    <div class="icon-column">
      <span class="material-icons">
        {{ currentAccordion === date ? 'expand_less' : 'expand_more' }}
      </span>
    </div>
    <div class="text-column">
      <div class="header-text">
        {{ formattaData(date) }}
        <!-- Aggiungi qui la verifica per "SOLD OUT" -->
        <span v-if="slots.length === 0" class="sold-out">SOLD OUT</span>
      </div>
    </div>
  </div>
  <!-- Mostra gli slot di quel giorno se l'accordion è aperto -->
  <div v-if="currentAccordion === date && slots.length > 0" class="order-details">
    <div class="grid-container23" v-for="slot in slots" :key="slot.time">
  <p>Orario: {{ slot.time }}</p>
  <p v-if="slot.alert" class="alert">{{ slot.alert }}</p>
  <button @click="prenota(date, slot.time, slot)">Prenota</button>
</div>
  </div>
</div>


      </div>
  </div>
</template>




<script>
import { ref, onMounted } from 'vue';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc, collection, query, where, getDocs, getDoc } from 'firebase/firestore';

export default {
  setup() {
    const auth = getAuth();
    const db = getFirestore();
    const userId = ref(null);
    const slotsByDate = ref({});
    const currentAccordion = ref(null);
    const prenotazioniUtente = ref([]);
    const alertMessage = ref('');  // Aggiunto per gestire il messaggio di alert


    function formattaData(dataInput) {
      let [anno, mese, giorno] = dataInput.split('-');
      if (anno && anno.length === 4) {
        return `${giorno.padStart(2, '0')}-${mese.padStart(2, '0')}-${anno}`;
      } else {
        return dataInput; // Gestisce il caso in cui la data sia già nel formato desiderato
      }
    }

    async function caricaPrenotazioni() {
      if (!userId.value) return;
      const q = query(collection(db, "prenotazioni"), where("userId", "==", userId.value));
      const querySnapshot = await getDocs(q);
      prenotazioniUtente.value = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    }


    

    async function filterBookedSlots() {
  let generatedSlots = generateSlotsForWeek(); // Assumiamo che questa funzione generi tutti gli slot possibili per la settimana
  const slotsCollection = collection(db, 'prenotazioni');
  // Ottieni tutte le prenotazioni con stato 'Booked'
  const q = query(slotsCollection, where('stato', '==', 'Booked'));
  const querySnapshot = await getDocs(q);

  let bookedSlots = {};
  querySnapshot.forEach(doc => {
    const { data, orario } = doc.data();
    const slotIdBase = `slot_${data}_${orario.replace(':', '')}`;
    if (!bookedSlots[slotIdBase]) {
      bookedSlots[slotIdBase] = 1;
    } else {
      bookedSlots[slotIdBase]++;
    }
  });

  // Filtrare gli slot che sono completamente prenotati
  for (const date in generatedSlots) {
    slotsByDate.value[date] = generatedSlots[date].filter(slot => {
      const slotIdBase = `slot_${date}_${slot.time.replace(':', '')}`;
      return !(bookedSlots[slotIdBase] && bookedSlots[slotIdBase] >= 3);
    });
  }
}





const generateSlotsForWeek = () => {
  let slots = {};
  let now = new Date();
  for (let i = 0; i < 8; i++) { // Ciclo per i prossimi 7 giorni
    let tempDate = new Date();
    tempDate.setDate(now.getDate() + i);
    if (tempDate.getDay() !== 0 && tempDate.getDay() !== 6) { // Esclude sabato e domenica
      let dateString = tempDate.toISOString().split('T')[0];
      slots[dateString] = [];
      for (let hour = 8; hour <= 18; hour += 0.5) {
        // Se i == 0, controlla se l'ora dello slot è almeno 2 ore dopo l'ora attuale
        if (i === 0 && now.getHours() + 2 > hour) continue;
        const fullHour = Math.floor(hour);
        const minutes = (hour % 1 === 0.5) ? '30' : '00';
        slots[dateString].push({
  time: `${fullHour.toString().padStart(2, '0')}:${minutes}`,
  isBooked: 0,
  alert: ''  // Aggiunto per gestire l'alert specifico per questo slot
});      }
    }
  }
  return slots;
};






async function prenota(date, time, slot) {
  slot.alert = '';  // Reset dell'alert per lo specifico slot

  if (!userId.value) {
    slot.alert = "Nessun utente autenticato.";
    setTimeout(() => slot.alert = '', 10000); // Pulisce l'alert dopo 10 secondi
    return;
  }

  // Controlla se l'utente ha già prenotazioni
  if (prenotazioniUtente.value.length > 0) {
    const ultimaPrenotazione = new Date(prenotazioniUtente.value[prenotazioniUtente.value.length - 1].data);
    const nuovaPrenotazione = new Date(date);

    // Calcola la differenza in giorni tra l'ultima prenotazione e la nuova
    const differenzaGiorni = (nuovaPrenotazione - ultimaPrenotazione) / (1000 * 3600 * 24);

    if (differenzaGiorni < 25) {
      slot.alert = "Hai già uno slot prenotato, se lo hai prenotato per errore, scrivi a team@fusco.fit";
      setTimeout(() => slot.alert = '', 10000);  // Pulisce l'alert dopo 10 secondi
      return;
    }
  }

  // Verifica se l'utente ha le approvazioni necessarie con 'videocall' impostato su "SI"
  const alimentazioniRef = collection(db, "alimentazioni");
  const alimentazioniSnapshot = await getDocs(alimentazioniRef);
  let approvazioniVideocall = 0;
  alimentazioniSnapshot.forEach((doc) => {
    const alimentazioni = doc.data().alimentazioni;
    // Verifica che l'utente corrispondente all'userID abbia approvazioni con 'videocall="SI"'
    if (doc.data().userId === userId.value) {
      alimentazioni.forEach((alim) => {
        if (alim.videocall === "SI") {
          approvazioniVideocall++;
        }
      });
    }
  });

  // Calcola il numero di slot prenotabili in base alle approvazioni 'videocall="SI"'
  const slotPrenotabili = approvazioniVideocall;

  // Ottiene il conteggio delle prenotazioni future dell'utente
  const now = new Date();
  const prenotazioniFuturo = prenotazioniUtente.value.filter(p => new Date(p.data) >= now).length;

  if (slotPrenotabili <= prenotazioniFuturo) {
    slot.alert = "Non puoi prenotare un nuovo slot.";
    setTimeout(() => slot.alert = '', 10000);  // Pulisce l'alert dopo 10 secondi
    return;
  }

  const slotBaseId = `slot_${date}_${time.replace(':', '')}`;
  const slotsQuery = query(collection(db, "prenotazioni"), where("id", ">=", slotBaseId), where("id", "<", slotBaseId + 'z'));
  const querySnapshot = await getDocs(slotsQuery);

  if (querySnapshot.size >= 4) {
    alertMessage.value = "Questo slot non è prenotabile.";
    return;
  }

  // Calcola il nuovo progressivo per l'ID basandosi sulle prenotazioni esistenti
  const newProgressive = querySnapshot.size + 1;
  const newSlotId = `${slotBaseId}_${newProgressive}`;

  // Verifica l'unicità del nuovoSlotId prima di procedere
  const newSlotRef = doc(db, "prenotazioni", newSlotId);
  const docSnap = await getDoc(newSlotRef);
  if (docSnap.exists()) {
    alertMessage.value = "Errore di prenotazione, per favore riprova.";
    return;
  }

  // Crea un nuovo documento con il newSlotId
  await setDoc(newSlotRef, {
    id: newSlotId,
    userId: userId.value,
    data: date,
    orario: time,
    stato: 'Booked'
  });

  slot.alert = "Prenotato";
  setTimeout(() => slot.alert = '', 10000);  // Pulisce l'alert dopo 10 secondi
  await caricaPrenotazioni();
  await filterBookedSlots();
}







    const toggleAccordion = (date) => {
      currentAccordion.value = currentAccordion.value === date ? null : date;
    };

    onMounted(async () => {
      if (auth.currentUser) {
        userId.value = auth.currentUser.uid;
        await caricaPrenotazioni();
        await filterBookedSlots();
      }
    });

    return { slotsByDate, currentAccordion, prenota, toggleAccordion, prenotazioniUtente, formattaData, alertMessage };
  },
  methods: {
      goBack() {
        this.$router.go(-1);
      },
    }
};
</script>









<style scoped>

.card-header2 {
    background: linear-gradient(45deg, #878787 0%, #bababa 100%);
    margin: 20px 0;
}
.material-icons{
  color:#dedede
}

.white-text {
  color: white;
}
.titolo-card {
  color:#ffffff;
}
.order-details {
    display: block;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(45deg, #141414 0%, #292929 100%);
    color: rgb(23, 23, 23);
    border-radius: 13px;
    margin: 20px 0;
    padding: 13px 8px 13px 23px;
    position: relative;
}
.alert {
  color: red;       /* Imposta il colore del testo a rosso */
  font-weight: bold; /* Imposta il testo in grassetto */
  margin-top: 3px;  /* Aggiunge un margine superiore per separarlo dal bottone */
  margin-bottom: 0px;
}


.sold-out {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}


/* Assicurati che queste regole siano incluse nel tag <style> del tuo componente Vue */
.prenotazioni-riepilogo {
  display: flex;
  flex-direction: column; /* Imposta gli elementi in colonna */
  margin-top: 20px;
  background-color: #424242;
  border-radius: 8px;
  color:#ffffff;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  align-items: center; /* Centra gli elementi orizzontalmente */
  justify-content: center; /* Centra gli elementi verticalmente */
}

.prenotazioni-riepilogo h2 {
  color: #ffffff;
  margin-bottom: 10px;
}

p {
  color:#e4e4e4
}

.titolo-card h3{
  color:rgb(228, 0, 0)
}
/* Stilizzazione generale per desktop, che verrà sovrascritta per mobile se necessario */
.grid-container23 {
  display: flex;
  flex-direction: column; /* Imposta gli elementi in colonna */
  align-items: center; /* Centra gli elementi orizzontalmente */
  justify-content: center; /* Centra gli elementi verticalmente */
  gap: 10px; /* Distanza tra gli elementi */
}

.grid-container23 p {
  margin: 0; /* Rimuove il margine predefinito */
}

.grid-container23 button {
  padding: 17px 20px; /* Aumenta lo spazio interno per ingrandire il bottone */
  font-size: 16px; /* Aumenta la dimensione del font nel bottone */
  cursor: pointer; /* Cambia il cursore in una mano per indicare la possibilità di clic */
  border: none; /* Rimuove il bordo predefinito */
  background-color: #004726; /* Colore di sfondo (esempio: blu) */
  color: white; /* Colore del testo */
  border-radius: 27px; /* Arrotonda gli angoli del bottone */
  transition: background-color 0.3s; /* Effetto di transizione per il passaggio del mouse */
  margin-bottom: 35px;
  width: 300px; /* Opzionale: limita la larghezza massima del bottone */

}

.grid-container23 button:hover {
  background-color: #00a34c; /* Cambia colore al passaggio del mouse */
}

/* Media query per dispositivi con larghezza inferiore a 768px (tipicamente dispositivi mobile) */
@media (max-width: 768px) {
  .grid-container23 {
    flex-direction: column; /* Conferma che gli elementi siano in colonna */
  }

  .grid-container23 button {
    width: 100%; /* Imposta la larghezza del bottone al 100% del contenitore per ingrandirlo */
    max-width: 300px; /* Opzionale: limita la larghezza massima del bottone */
  }
}
</style>

  